<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="selectedValue"
    (selectionChange)="onSelectionChange($event.value)"
    [multiple]="multipleSelection"
    [compareWith]="compareWithFn"
    [disabled]="disabled"
  >
    <mat-select-trigger *ngIf="formatMultiSelectedValues && selectedValue?.length">
      <span *ngIf="selectedValue.length === 1">
        {{ selectedValue[0].name }}
      </span>
      <span *ngIf="selectedValue.length > 1">
        {{ selectedValue.length + ' selected' }}
      </span>
    </mat-select-trigger>
    <mat-option class="search-option">
      <input
        matInput
        placeholder="Search..."
        [formControl]="searchControl"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        (keydown.enter)="$event.preventDefault()"
        autocomplete="off"
      />
    </mat-option>

    <mat-option *ngFor="let item of filteredOptions" [value]="item">
      {{ item[displayProperty] }}
    </mat-option>
  </mat-select>
</mat-form-field>
